import { createSlice } from '@reduxjs/toolkit';

/**
 * Initial state for user management in the Redux store.
 * @author govind dindewad
 */
const initialState = {
    isUpdateDetails: false,         // Flag to track if user details are being updated
    userDetailsRoute: null,         // Route related to user detail navigation
    userData: null,                 // Currently selected user's full data
    userRoutePath: '/user',         // Default route path for user module
    selectedUser: null,             // Selected user for profile or actions
    userList: null,                // Cached list of users (if fetched)
    userCountData:null,
    profileInfo:JSON.parse(localStorage?.getItem('userData')),
    walletlDetailData:null,
    transactions:null
};

/**
 * Redux slice for user-related state management.
 * 
 * Includes actions for setting flags, user data, and navigation context.
 */
const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        /**
         * Set the flag for update mode.
         * @param {Object} state 
         * @param {Object} action - Boolean value indicating update mode.
         */
        setIsUpdateDetails: (state, action) => {
            state.isUpdateDetails = action.payload;
        },

        /**
         * Set the route for user detail navigation.
         * @param {Object} state 
         * @param {Object} action - Route string.
         */
        setUsrDetailsRoute: (state, action) => {
            state.userDetailsRoute = action.payload;
        },

        /**
         * Set user-specific data.
         * @param {Object} state 
         * @param {Object} action - User data object.
         */
        setUserData: (state, action) => {
            state.userData = action.payload;
        },

        /**
         * Set the route path for user module navigation.
         * @param {Object} state 
         * @param {Object} action - Route path string.
         */
        setUserRoutePath: (state, action) => {
            state.userRoutePath = action.payload;
        },

        /**
         * Set the selected user object (e.g. for view/edit).
         * @param {Object} state 
         * @param {Object} action - Selected user object.
         */
        setSelectedUser: (state, action) => {
            state.selectedUser = action.payload;
        },

        /**
         * Set the user list, likely from an API response.
         * @param {Object} state 
         * @param {Object} action - Array of user objects.
         */
        setUserList: (state, action) => {
            state.userList = action.payload;
        },
        setUserCountData:(state, action)=>{
            state.userCountData=action.payload;
        },
        setProfileInfo:(state, action)=>{
            state.profileInfo = action.payload
        },
        setWalletDetalData:(state, action)=>{
            state.walletlDetailData = action.payload
        },
        setTransactions:(state, action)=>{
            state.transactions = action.payload
        }
    },

    // Optional: Reset state globally if needed using 'RESET_STATE'
    extraReducers: (builder) => {
        builder.addCase('RESET_STATE', () => initialState);
    }
});

// Export actions for use in components or thunks
export const {
    setIsUpdateDetails,
    setUsrDetailsRoute,
    setUserData,
    setUserRoutePath,
    setSelectedUser,
    setUserList,
    setUserCountData,
    setProfileInfo,
    setWalletDetalData,
    setTransactions
    
} = userSlice.actions;

// Export the reducer to be included in the Redux store
export default userSlice.reducer;
